import { ServerMeshEndpointInfo, ServerMeshEndpointNodeInfo } from '@/api/type-server'

import { endpointNetStatusMap, EndpointStatus } from './network'

export class MeshEndpoint {
  resID: string
  status: number
  cidr: string
  mac: string
  createTime: Date
  ownerID?: number
  ownerType?: number
  instResID?: string
  subject?: string
  endpointNodeInfo?: ServerMeshEndpointNodeInfo
  isPurchased?: boolean

  constructor(props: ServerMeshEndpointInfo) {
    const { endpointInfo } = props

    this.resID = props.resID
    this.status = props.status
    this.cidr = props.cidr
    this.mac = props.mac
    this.createTime = new Date(props.createTime.seconds * 1000)
    this.ownerID = props.ownerID
    this.ownerType = props.ownerType
    this.instResID = props.instResID
    this.subject = props.flag?.subject
    this.endpointNodeInfo = endpointInfo?.node
    this.isPurchased = props.isPurchased
  }

  get formattedCreateTime() {
    return this.createTime.toLocaleString()
  }

  get displayTitle() {
    return this.subject || this.endpointNodeInfo?.gpuName || this.endpointNodeInfo?.cpuName || '-'
  }

  get statusText() {
    return (
      endpointNetStatusMap[this.status as EndpointStatus]?.label ??
      endpointNetStatusMap[EndpointStatus.InvalidStatus]?.label
    )
  }

  get statusTextStyle() {
    return (
      endpointNetStatusMap[this.status as EndpointStatus]?.style ??
      endpointNetStatusMap[EndpointStatus.InvalidStatus]?.style
    )
  }
}

export class ClusterInstance {
  resID: string
  gpuName?: string
  cpuName?: string
  subject?: string
  displayTitle: string

  // disabled for transfer
  disabled: boolean

  constructor(props: ServerMeshEndpointNodeInfo) {
    this.resID = props.resID
    this.gpuName = props.gpuName
    this.cpuName = props.cpuName
    this.subject = props.flag?.subject
    this.displayTitle = this.subject || this.gpuName || this.cpuName || '-'
    this.disabled = false
  }
}
